
import { Vue } from "vue-class-component";

export default class RegisterWarrantyBanner extends Vue {}
